import {inject} from '@angular/core';
import {TranslateService as RuntimeTranslateService} from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import {ChoiceScreenService} from "../../../../services/choice-screen.service";
import {ChoiceScreen} from "../../../../models/choice-screen.model";
import {ChoiceScreenGroupes} from "../../../../models/choice-screen-groupes.model";
import Swal from "sweetalert2";
import {ActivatedRoute, Router} from "@angular/router";
@Component({
    selector: 'app-choice-screen',
    templateUrl: './list-choice-screen.component.html',
    styleUrls: ['./list-choice-screen.component.css'],
    standalone: false
})
export class ListChoiceScreenComponent implements OnInit {
  private readonly runtimeTranslate = inject(RuntimeTranslateService);

  public user_conntected = JSON.parse(localStorage.getItem('currentUser'));
  // tslint:disable-next-line:variable-name
  public profile_id = this.user_conntected.profile_id;

  //delete ChoiceScreen
  responseMessage : string;

  constructor(private choiceScreenService: ChoiceScreenService,
              private router: Router,
              private route: ActivatedRoute) { }

  ngOnInit() {
    if(this.profile_id ==11){
      this.getAllScreenChoice();
    }
  }

  AllChoiceScreen: ChoiceScreen[] = [];
  ChoiceScreenGroupe : ChoiceScreenGroupes[] = [];

  getAllScreenChoice() {
    this.choiceScreenService.getAllChoiceScreen()
      .subscribe(res => {
        this.AllChoiceScreen = res.choiceScreen
      }, (err) => {
        console.log(err);
      });
  }

  // tslint:disable-next-line:variable-name
  update(id) {
    this.router.navigate(['/dashboard/administrator/choice_screen/edit/' + id], { relativeTo: this.route });
  }
// tslint:disable-next-line:variable-name
  delete(id) {
    Swal.fire({
      title: this.runtimeTranslate.instant('alerts.confirmDelete'),
      text: this.runtimeTranslate.instant('alerts.irreversible'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.runtimeTranslate.instant('alerts.yesDelete'),
      cancelButtonText: this.runtimeTranslate.instant('common.cancel')
    }).then((result) => {
      if (result.value) {
        // @ts-ignore
        this.choiceScreenService.deleteChoiceScreen(id)
          .subscribe(res => {
            this.responseMessage = res.message;
            Swal.fire(
              this.runtimeTranslate.instant('alerts.deleted'),
              this.runtimeTranslate.instant('alerts.choiceScreenDeleted'),
              'success'
            ).then(() => {
              window.location.reload();
              this.getAllScreenChoice();
            });
          }, (err) => {
            Swal.fire(
              this.runtimeTranslate.instant('alerts.error'),
              this.runtimeTranslate.instant('alerts.deletionError'),
              'error'
            );
          });
      }
    });
  }

}
